export default "__VITE_ASSET__BygUalQK__"